// firebase.js
import { initializeApp } from "firebase/app";
import { getDatabase, ref, onValue } from "firebase/database";

const firebaseConfig = {
  apiKey: "AIzaSyBrFx_85o8ndnznZIXyBr-E7tuBFtcm_tc",
  authDomain: "emslocal-cbb4a.firebaseapp.com",
  databaseURL: "https://emslocal-cbb4a-default-rtdb.firebaseio.com",
  projectId: "emslocal-cbb4a",
  storageBucket: "emslocal-cbb4a.firebasestorage.app",
  messagingSenderId: "931017876501",
  appId: "1:931017876501:web:c5b6bac303014b0ab29a1c",
  measurementId: "G-PGNDD58QJR",
};

const app = initializeApp(firebaseConfig);
const database = getDatabase(app);

export { database, ref, onValue };